import React, { useContext } from 'react'
import CompanyProfileCard from './companyProfileCard/CompanyProfileCard'
import { Box, Grid, styled } from '@mui/material'
import companyProfiles from '../../assets/data/companyProfile'
import { ThemeContext } from '../../context/ThemeContext';


const CardWrapper = styled(Grid)(({ theme }) => ({
  marginBottom: theme.spacing(2),
}));


function CompanyProfilesSection() {

    const { inputValue, selectedFilter, filterByCategory } = useContext(ThemeContext);

    const filteredCompanyProfiles = companyProfiles.filter(companyProfile => {
        const matchesKeyword = inputValue
          ? companyProfile.title.toLowerCase().includes(inputValue.toLowerCase())
          : true;
    
        const matchesSector = filterByCategory
          ? companyProfile.category === filterByCategory
          : true;
    
        return matchesKeyword && matchesSector;
      });

  return (
    <CardWrapper container rowSpacing={2} columnSpacing={2} justifyContent="center" >
      {filteredCompanyProfiles.map((companyProfile) => (
        <CompanyProfileCard key={companyProfile} image={companyProfile.image} title={companyProfile.title} info={companyProfile.info} publishedOn={companyProfile.publishDate} price={companyProfile.price} category={companyProfile.category} />
      ))}
    </CardWrapper>
  )
}

export default CompanyProfilesSection
